import { render, staticRenderFns } from "./otherStore.vue?vue&type=template&id=dc6f9522&scoped=true"
import script from "./otherStore.vue?vue&type=script&lang=js"
export * from "./otherStore.vue?vue&type=script&lang=js"
import style0 from "./otherStore.vue?vue&type=style&index=0&id=dc6f9522&prod&lang=scss&scoped=true"
import style1 from "./otherStore.vue?vue&type=style&index=1&id=dc6f9522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6f9522",
  null
  
)

export default component.exports